import { ApplicationView } from "@mixitone/mvc";
import { omit } from "@mixitone/util";
import type { PropsWithChildren } from "react";
import Field from "./Field";
import { Label, type LabelProps } from "./Label";
import { twMerge } from "tailwind-merge";

type Props = LabelProps & {
  label: React.ReactNode;
  helpText?: React.ReactNode;
  required?: boolean;
  inline?: boolean;
  showRequiredIndicator?: boolean;
};

const ControlledLabelledField: React.FC<PropsWithChildren<Props>> = (props) => {
  const { label, helpText, children, inline, showRequiredIndicator, ...labelProps } = props;
  const className = inline ? "flex items-center justify-between" : "";

  // Omit showRequiredIndicator from props passed to Label to avoid React warning
  const labelPropsWithoutIndicator = omit(labelProps as LabelProps & { showRequiredIndicator?: boolean }, [
    "showRequiredIndicator",
  ]);

  return (
    <Field>
      <div className={className}>
        <Label
          {...labelPropsWithoutIndicator}
          className={twMerge("text-sm medium:text-base", labelProps.className)}
        >
          {label}
          {props.required && showRequiredIndicator !== false && (
            <span className="text-red-700 text-xs -translate-y-1 translate-x-1 inline-block">(required)</span>
          )}
        </Label>
        {children}
      </div>
      {helpText && <p className="mt-1 text-xs text-gray-500">{helpText}</p>}
    </Field>
  );
};

const LabelledField = ApplicationView(ControlledLabelledField);
export { LabelledField };
